import {
  SET_ACTIVE_SUBSCRIPTION_COUNT,
  SET_IN_ACTIVE_SUBSCRIPTION_COUNT,
  SET_PROFILE_COMPLETED,
  SET_SELLER_SERVICES,
  SET_DISABLE_SELLER_REDIRECTION,
  SET_TOS_SIGNED,
} from '../constants/AppConstants';

const initialState = {
  sellerServices: [],
  profileCompleted: false,
  inActiveSubscriptionsCount: 0,
  activeSubscriptionsCount: 0,
  disableRedirection:false,
  tosSigned:false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SELLER_SERVICES: {
      const sellerServices = action.payload;
      return {
        ...state,
        sellerServices
      }
    }
    case SET_PROFILE_COMPLETED: {
      const profileCompleted = action.payload;
      return{
        ...state,
        profileCompleted
      }
    }
    case SET_IN_ACTIVE_SUBSCRIPTION_COUNT: {
      const inActiveSubscriptionsCount = action.payload;
      return {
        ...state,
        inActiveSubscriptionsCount
      }
    }
    case SET_ACTIVE_SUBSCRIPTION_COUNT: {
      const activeSubscriptionsCount = action.payload;
      return {
        ...state,
        activeSubscriptionsCount
      }
    }
    case SET_DISABLE_SELLER_REDIRECTION: {
      const disableRedirection = action.payload;
      return {
        ...state,
        disableRedirection
      }
    }
    case SET_TOS_SIGNED: {
      const tosSigned = action.payload;
      return {
        ...state,
        tosSigned
      }
    }
    default: {
      return state;
    }
  }
};
